import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken';

export async function saveDraft(draft) {
  const token = await retrieveAccessToken();
  await axios.post('/api/editor/draft', draft, {
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
  });
}
